import { useCallback, useEffect, useMemo, useState } from 'react';

export const useAccordion = (items: any[]) => {
  const [accItems, setItems] = useState<any[]>([]);

  const assignedItemsArr = useMemo(
    () => accItems.filter(({ assigned }: any) => assigned === true),
    [accItems]
  );

  const notAssignedItemsArr = useMemo(
    () => accItems.filter(({ assigned }: any) => assigned === false),
    [accItems]
  );

  const mapedAccordionItems = useMemo(
    () => items.map((item: any) => ({ ...item, active: false, assigned: item?.selected ?? true })),
    [items]
  );

  const setItemStatus = useCallback(
    (id: string) => {
      const newAccState = accItems.map((item: any) =>
        item.id === id ? { ...item, active: !item.active } : item
      );
      setItems(newAccState);
    },
    [accItems]
  );

  const closeOpenAll = (active: boolean) => {
    const newAccState = accItems.map((item: any) => ({ ...item, active }));
    setItems(newAccState);
  };

  const extendButtonState = useMemo(() => {
    return !!accItems.find((item: any) => item.active === true);
  }, [accItems]);

  const changeItemAssigment = useCallback(
    (id: string) => {
      const newAccState = accItems.map((item: any) =>
        item.id === id ? { ...item, assigned: !item.assigned } : item
      );
      setItems(newAccState);
    },
    [accItems]
  );

  const changeItemsAssigment = useCallback(
    (ids: string[]) => {
      const newAccState = accItems.map((item: any) =>
        ids.includes(item.id) ? { ...item, assigned: !item.assigned } : item
      );
      setItems(newAccState);
    },
    [accItems]
  );

  const changeMultipleItemsAssignment = useCallback(
    (ids: string[]) => {
      if (ids.length === 0) {
        setItems(accItems => accItems.map(item => ({ ...item, assigned: false })));
        return;
      }

      const newAccState = accItems.map((item: any) =>
        ids.includes(item.id) ? { ...item, assigned: true } : { ...item, assigned: false }
      );

      setItems(newAccState);
    },
    [accItems]
  );

  useEffect(() => {
    setItems(mapedAccordionItems);
  }, [mapedAccordionItems]);

  return {
    itemsArr: accItems,
    assignedItemsArr,
    notAssignedItemsArr,
    setItemStatus,
    closeOpenAll,
    extendButtonState,
    changeItemAssigment,
    changeItemsAssigment,
    changeMultipleItemsAssignment,
  };
};
